var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 15.875C9.26824 15.875 5.73674 14.2939 3.05399 11.423C2.72412 11.0704 2.74337 10.5165 3.09599 10.1866C3.44949 9.85675 4.00249 9.876 4.33324 10.2286C6.68087 12.7416 9.75824 14.125 13.0001 14.125C17.1677 14.125 21.0055 11.8456 23.3601 8C21.0064 4.15438 17.1677 1.875 13.0001 1.875C8.67937 1.875 4.71212 4.32588 2.38637 8.43138C2.14837 8.85225 1.61287 9.001 1.19374 8.76125C0.772868 8.52325 0.625868 7.9895 0.863868 7.56862C3.50374 2.9075 8.04149 0.125 13.0001 0.125C17.9596 0.125 22.4965 2.9075 25.1364 7.56862C25.2877 7.83637 25.2877 8.16363 25.1364 8.4305C22.4965 13.0916 17.9596 15.875 13.0001 15.875Z",
    fill: "#FFC557"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.375C10.5876 12.375 8.625 10.4124 8.625 8C8.625 5.58763 10.5876 3.625 13 3.625C15.4124 3.625 17.375 5.58763 17.375 8C17.375 10.4124 15.4124 12.375 13 12.375ZM13 5.375C11.5527 5.375 10.375 6.55275 10.375 8C10.375 9.44725 11.5527 10.625 13 10.625C14.4472 10.625 15.625 9.44725 15.625 8C15.625 6.55275 14.4472 5.375 13 5.375Z",
    fill: "#FFC557"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.01de56741b1ddec95caa7e596699fcd6.svg";
export { ForwardRef as ReactComponent };